const getReactAppUrl = (): string =>
    process.env[
        `REACT_APP_URL_${process.env.REACT_APP_THEME.toUpperCase()}`
    ] as string;
export default getReactAppUrl;
